var JobMatchMeetingsController = /** @class */ (function () {
    /*@ngInject*/
    function JobMatchMeetingsController($rootScope, $timeout, $filter, $uibModal, moment, dateTimeUtilityService, DTOptionsBuilder, meetingService, jobMatchService, userRoleService, companyService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$uibModal = $uibModal;
        this.moment = moment;
        this.dateTimeUtilityService = dateTimeUtilityService;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.meetingService = meetingService;
        this.jobMatchService = jobMatchService;
        this.userRoleService = userRoleService;
        this.companyService = companyService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    JobMatchMeetingsController.prototype.$onInit = function () {
        this._init();
    };
    JobMatchMeetingsController.prototype._init = function () {
        var _this = this;
        //variables
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.meetingsList = [];
        this.meetingUserType = '';
        this.browserTimeZone = null;
        this.meetingsLabel = '';
        this.candidateJobMatch = {};
        //flags
        this.loadingFlag = true;
        this.loadingJobMatchInfoFlag = true;
        this.isCorporate = this.companyService.isCorporateCompany();
        this.dtOptions = this.DTOptionsBuilder.newOptions().withOption('paging', false).withOption('ordering', false);
        this.dtColumnDefs = [];
        this.browserTimeZone = this.dateTimeUtilityService.guessBrowserTimeZoneName();
        if (this.meetingType == 'PhoneScreen') {
            this.meetingUserType = 'Phone Screener';
            this.meetingsLabel = 'Phone Screens';
        }
        else if (this.meetingType == 'Interview') {
            this.meetingUserType = 'Interviewer';
            this.meetingsLabel = 'Interviews';
        }
        // get the candidate job match meetings
        this.loadingFlag = true;
        this.getCandidateJobMatchCardInfo(function () {
            _this.getScheduledItems();
        });
    };
    JobMatchMeetingsController.prototype.getScheduledItems = function () {
        var _this = this;
        this.loadingFlag = true;
        var loggedInUserId = null;
        if (this.meetingType == 'PhoneScreen') {
            this.jobMatchService.getPhoneScreeners(this.jobMatchId, this.companyId, loggedInUserId, true, function (data) {
                _this.meetingsList = _this._getMeetingsList(data);
            }, function (error) {
                _this.loadingFlag = false;
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
        else if (this.meetingType == 'Interview') {
            this.jobMatchService.getInterviewers(this.jobMatchId, this.companyId, loggedInUserId, true, function (data) {
                _this.loadingFlag = false;
                _this.meetingsList = _this._getMeetingsList(data);
            }, function (error) {
                _this.loadingFlag = false;
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    };
    JobMatchMeetingsController.prototype._getMeetingsList = function (response) {
        var _this = this;
        var meetingsList = [];
        angular.forEach(response, function (meetingDetails, key) {
            var meeting = _this._setMeeting(meetingDetails, null, true);
            meetingsList.push(meeting);
            angular.forEach(meetingDetails.childMeetingSchedules, function (childMeeting, index) {
                var childMeetingTemp = _this._setMeeting(childMeeting, meeting.id, false);
                meetingsList.push(childMeetingTemp);
            });
        });
        this.loadingFlag = false;
        return meetingsList;
    };
    JobMatchMeetingsController.prototype._setMeeting = function (meetingDetails, parentScheduleId, isParentMeeting) {
        var _this = this;
        var workflowStep = this.meetingType == 'PhoneScreen' ? 'ps' : 'in';
        var meeting = {};
        meeting.id = meetingDetails.meetingScheduleId;
        meeting.status = meetingDetails.status;
        meeting.candidateEmail = meetingDetails.candidateEmail;
        meeting.feedbackType = meetingDetails.feedbackType;
        meeting.isNotValid = meetingDetails.isNotValid;
        meeting.parentScheduleId = isParentMeeting ? meeting.id : parentScheduleId;
        meeting.childScheduleId = isParentMeeting ? null : meeting.id;
        meeting.feedbackTooltip = 'Click to view feedback.';
        meeting.meetingMode = meetingDetails.meetingMode;
        meeting.meetingUrl = this.meetingService.getMeetingUrl(meeting.id, workflowStep, meeting.meetingMode);
        this._setMeetingCount(meeting, meetingDetails.meetingCount);
        meeting.notesDisplay = "";
        if (!_.isNull(meetingDetails.internalNote) && meetingDetails.internalNote.length > 0) {
            if (this.candidateJobMatch.isSharedRequisition) {
                meeting.notesDisplay = meeting.notesDisplay + "<b>Internal Note: </b> <p>" + this._replaceSpecialCharacters(meetingDetails.internalNote) + "</p>";
            }
            else {
                meeting.notesDisplay = meeting.notesDisplay + "<b>Note: </b><p>" + this._replaceSpecialCharacters(meetingDetails.internalNote) + "</p>";
            }
        }
        if (!_.isNull(meetingDetails.externalNote) && meetingDetails.externalNote.length > 0) {
            meeting.notesDisplay = meeting.notesDisplay + "<b>External Note: </b><br><p>" + this._replaceSpecialCharacters(meetingDetails.externalNote) + "</p>";
        }
        if (meeting.notesDisplay.length > 0) {
            meeting.notesDisplay = "<div class='text-left' style='padding-top:8px'>" + meeting.notesDisplay + "</div>";
        }
        meeting.notesTooltipIsOpen = false;
        switch (meeting.status) {
            case 'SCHEDULED':
                meeting.statusClass = 'fa fa-calendar job-match-meetings-meeting-icon-scheduled';
                meeting.statusLabel = 'Scheduled';
                meeting.feedbackEnabledFlag = true;
                break;
            case 'IN_PROGRESS':
                meeting.statusClass = 'fa fa-hourglass-half job-match-meetings-meeting-icon-in-progress';
                meeting.statusLabel = 'In Progress';
                meeting.feedbackEnabledFlag = true;
                break;
            case 'COMPLETED':
                meeting.statusClass = 'fa fa-check job-match-meetings-meeting-icon-completed';
                meeting.statusLabel = 'Completed';
                meeting.feedbackEnabledFlag = true;
                break;
            case 'OVERDUE':
                meeting.statusClass = 'fas fa-clock job-match-meetings-meeting-icon-overdue';
                meeting.statusLabel = 'Overdue';
                meeting.feedbackEnabledFlag = true;
                break;
            case 'CANCELLED':
                meeting.statusClass = 'fa fa-ban job-match-meetings-meeting-icon-cancelled';
                meeting.statusLabel = 'Canceled';
                meeting.feedbackEnabledFlag = false;
                meeting.feedbackTooltip = 'Feedback is disabled.';
                break;
            default:
                // set defaults
                meeting.statusClass = 'fa fa-question job-match-meetings-meeting-icon-in-progress';
                meeting.statusLabel = 'Status Unknown';
                meeting.feedbackEnabledFlag = false;
                meeting.feedbackTooltip = 'Feedback is disabled.';
        }
        var startDateTime = new Date(meetingDetails.meetingStartTime);
        var endDateTime = new Date(meetingDetails.meetingEndTime);
        meeting.timeZone = _.isNull(meetingDetails.timeZone) ? '-' : meetingDetails.timeZone;
        if (meeting.timeZone != '-') {
            meeting.scheduledDateInBrowserTimeZone = startDateTime;
            meeting.scheduledTimeLabelInBrowserTimeZone = this.$filter('fourdotfiveTimeFormat')(startDateTime) + ' to ' + this.$filter('fourdotfiveTimeFormat')(endDateTime);
            var startDateTimeStringInSelectedTimeZone = this.moment(startDateTime).tz(meeting.timeZone).format("YYYY-MM-DDTHH:mm:ss.SSS");
            var startDateTimeInSelectedTimeZone = new Date(startDateTimeStringInSelectedTimeZone);
            var endDateTimeStringInSelectedTimeZone = this.moment(endDateTime).tz(meeting.timeZone).format("YYYY-MM-DDTHH:mm:ss.SSS");
            var endDateTimeInSelectedTimeZone = new Date(endDateTimeStringInSelectedTimeZone);
            meeting.scheduledDate = new Date(startDateTimeInSelectedTimeZone);
            meeting.scheduledTimeLabel = this.$filter('fourdotfiveTimeFormat')(startDateTimeInSelectedTimeZone) + ' to ' + this.$filter('fourdotfiveTimeFormat')(endDateTimeInSelectedTimeZone);
        }
        else {
            meeting.scheduledDate = startDateTime;
            meeting.scheduledTimeLabel = this.$filter('fourdotfiveTimeFormat')(startDateTime) + ' to ' + this.$filter('fourdotfiveTimeFormat')(endDateTime);
        }
        meeting.usersList = [];
        meeting.usersListToDisplay = [];
        angular.forEach(meetingDetails.participants, function (meetingUser, key) {
            var user = {};
            user.userId = meetingUser.id;
            user.userName = meetingUser.firstName;
            if (!_.isUndefined(meetingUser.lastName) && !_.isNull(meetingUser.lastName)) {
                user.userName += ' ' + meetingUser.lastName;
            }
            user.role = meetingUser.role;
            user.isPoc = meetingUser.isPoc;
            user.email = _.isNull(meetingUser.email) ? '-' : meetingUser.email;
            user.phoneNumber = _.isNull(meetingUser.phoneNumber) ? '-' : meetingUser.phoneNumber;
            user.title = _.isNull(meetingUser.title) ? '-' : meetingUser.title;
            // if(this.isCorporate) {
            //     meeting.showFeedback = true;
            // } else {
            //     meeting.showFeedback = this._getUserAccess(meetingUser.company.id);
            // }
            meeting.usersList.push(user);
            if (!_.isNull(meetingUser.participantMeetingEmailDeliveryDetails)) {
                var emailDeliveryDetails = meetingUser.participantMeetingEmailDeliveryDetails[0];
                if (emailDeliveryDetails.participantEmail == user.email) {
                    user.emailSendToParticipant = emailDeliveryDetails.emailSendToParticipant;
                    user.emailDeliveryReason = emailDeliveryDetails.reason;
                }
                if (user.emailSendToParticipant) {
                    user.emailDeliveryReason = "Email delivered.";
                }
                else if (_.isNull(user.emailDeliveryReason) || user.emailDeliveryReason == "") {
                    user.emailDeliveryReason = "Email not delivered.";
                }
            }
            if (_this.candidateJobMatch.isSharedRequisition && !_this.isCorporate) {
                if (user.isPoc) {
                    meeting.usersListToDisplay.push(user);
                }
            }
            else {
                meeting.usersListToDisplay.push(user);
            }
        });
        if (!_.isNull(meetingDetails.candidateMeetingEmailDeliveryInfo)) {
            var candidateEmailDeliveryDetails = meetingDetails.candidateMeetingEmailDeliveryInfo[0];
            meeting.emailSendToCandidate = candidateEmailDeliveryDetails.emailSendToCandidate;
            meeting.emailDeliveryReason = candidateEmailDeliveryDetails.reason;
            if (meeting.emailSendToCandidate) {
                meeting.emailDeliveryReason = "Email delivered.";
            }
            else if (_.isNull(meeting.emailDeliveryReason) || meeting.emailDeliveryReason == "") {
                meeting.emailDeliveryReason = "Email not delivered.";
            }
        }
        return meeting;
    };
    JobMatchMeetingsController.prototype._setMeetingCount = function (meeting, meetingCount) {
        if (meetingCount == 0) {
            meeting.meetingCount = "-";
        }
        else if (meetingCount == 1) {
            meeting.meetingCount = "1st";
        }
        else if (meetingCount == 2) {
            meeting.meetingCount = "2nd";
        }
        else if (meetingCount == 3) {
            meeting.meetingCount = "3rd";
        }
        else {
            meeting.meetingCount = meetingCount + "th";
        }
    };
    JobMatchMeetingsController.prototype._replaceSpecialCharacters = function (text) {
        var replacedText = text;
        for (var i = 0; i < replacedText.length; i++) {
            replacedText = replacedText.replace('<', '&lt;').replace('>', '&gt;');
        }
        replacedText = replacedText.replace(/&lt;br&gt;/g, '<br>');
        return replacedText;
    };
    JobMatchMeetingsController.prototype._getUserAccess = function (participantCompanyId) {
        return this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin() || participantCompanyId == this.companyId;
    };
    JobMatchMeetingsController.prototype.openFeedbackForm = function (meeting) {
        var _this = this;
        var userList = meeting.usersList;
        $(".modal").addClass("job-match-meetings-modal-large");
        this.$timeout(function () {
            _this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowTopClass: 'four-dot-five-modal-medium',
                backdrop: 'static',
                keyboard: false,
                component: 'jobMatchMeetingsFeedbackModal',
                resolve: {
                    candidateId: function () {
                        return _this.candidateJobMatch.id;
                    },
                    jobId: function () {
                        return _this.candidateJobMatch.jobMatchJobId;
                    },
                    jobMatchId: function () {
                        return _this.jobMatchId;
                    },
                    feedbackType: function () {
                        return _this.meetingType;
                    },
                    meetingUserList: function () {
                        return userList;
                    },
                    parentScheduleId: function () {
                        return meeting.parentScheduleId;
                    },
                    childScheduleId: function () {
                        return meeting.childScheduleId;
                    }
                }
            }).result.then(function (callback) {
                if (callback.callbackType == 'refresh') {
                    _this.feedbackCallback();
                }
                _this.$timeout(function () {
                    $(".modal").removeClass("job-match-meetings-modal-large");
                }, 600);
            }, function (dismiss) {
                _this.$timeout(function () {
                    $(".modal").removeClass("job-match-meetings-modal-large");
                }, 600);
            });
        }, 300);
    };
    JobMatchMeetingsController.prototype.feedbackCallback = function () {
        this._init();
        if (this.saveCallback) {
            this.saveCallback();
        }
    };
    JobMatchMeetingsController.prototype.getCandidateJobMatchCardInfo = function (successCallback) {
        var _this = this;
        this.loadingJobMatchInfoFlag = true;
        this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, function (data) {
            angular.merge(_this.candidateJobMatch, data);
            _this.candidateJobMatch = _this._massageCandidateJobMatchData(_this.candidateJobMatch);
            _this.loadingJobMatchInfoFlag = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    JobMatchMeetingsController.prototype._massageCandidateJobMatchData = function (candidateJobMatch) {
        candidateJobMatch.name = candidateJobMatch.firstName + ' ' + candidateJobMatch.lastName;
        if (candidateJobMatch.jobMatchRequisitionNum == null) {
            candidateJobMatch.jobMatchRequisitionNum = '-';
        }
        return candidateJobMatch;
    };
    return JobMatchMeetingsController;
}());
JobMatchMeetingsController.$inject = ['$rootScope', '$timeout', '$filter', '$uibModal', 'moment', 'dateTimeUtilityService', 'DTOptionsBuilder', 'meetingService', 'jobMatchService', 'userRoleService', 'companyService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './job-match-meetings.html;
import * as TEMPLATE from 'raw-loader!./job-match-meetings.html';
export var JobMatchMeetingsComponent = {
    selector: 'jobMatchMeetings',
    component: {
        bindings: {
            jobMatchId: '@',
            meetingType: '@',
            saveCallback: '&'
        },
        controller: JobMatchMeetingsController,
        // templateUrl: 'app/shared/jobMatchActions/jobMatchMeetings/job-match-meetings.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=job-match-meetings.component.js.map